import HomeIcon from '@mui/icons-material/Home';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { AgentRoles } from 'src/utils/constants/distributors';
import ClientsIcon from '@mui/icons-material/EmojiPeople';
import DistributorIcon from '@mui/icons-material/Hail';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { UserStatus } from 'src/utils/constants/common';

const distributorDirectorRoutes = [
  {
    title: 'NAVIGATION.GENERAL',
    children: [
      {
        href: '/user/home',
        icon: HomeIcon,
        title: 'USER_NAVIGATION.HOME'
      },
      {
        href: '/user/clients',
        icon: ClientsIcon,
        title: 'USER_NAVIGATION.MY_CLIENTS'
      },
      {
        href: '/user/distributor',
        icon: DistributorIcon,
        title: 'USER_NAVIGATION.MY_COMPANY'
      },
      {
        href: '/user/kams',
        icon: SupervisorAccountIcon,
        title: 'USER_NAVIGATION.KAMS'
      },
      {
        icon: ReceiptIcon,
        title: 'USER_NAVIGATION.QUOTES',
        href: '/user/quotes'
      }
    ]
  }
];

const getUserNavigationRoutes = (role, status) => {
  if (status === UserStatus.PENDING) {
    return [
      {
        title: 'NAVIGATION.GENERAL',
        children: [
          {
            href: '/user/home',
            icon: HomeIcon,
            title: 'USER_NAVIGATION.HOME',
            disabled: true
          }
        ]
      }
    ];
  }
  if (role === AgentRoles.DIRECTOR) {
    return distributorDirectorRoutes;
  }

  return [];
};

export default getUserNavigationRoutes;
